export interface ModularPreset {
  id: string;
  n: number;
  a: number;
  b: number;
  op: '+' | '*';
}

export const MODULAR_PRESETS: readonly ModularPreset[] = [
  { id: 'clock-7plus8', n: 12, a: 7, b: 8, op: '+' },
  { id: 'mod7-3plus0', n: 7, a: 3, b: 0, op: '+' },
  { id: 'mod5-2times0', n: 5, a: 2, b: 0, op: '*' },
];
